import { RootState } from '@Store/index';
import { createSelector } from '@reduxjs/toolkit';

const eventType = (state: RootState) => state.common.eventMessageType;

export const eventMessageType = createSelector(
  eventType,
  ({ eventType }) => eventType
);
